import { IMenuButton } from '../../../core/extension';

export interface IColourMap {
  label: string;
  colour?: string;
}

export type ColourMapWithButton = IMenuButton & Pick<IColourMap, 'colour'>;

export enum TextColour {
  Red = '#e04f44',
  Orange = '#bc5f1c',
  Yellow = '#cf940a',
  Blue = '#4c68d6',
  Purple = '#5f55ee',
  Pink = '#c75485',
  Green = '#259646',
  Grey = '#87909e',
}
export const TEXT_COLOURS: IColourMap[] = [
  {
    label: 'Default',
  },
  {
    label: 'Red',
    colour: TextColour.Red,
  },
  {
    label: 'Orange',
    colour: TextColour.Orange,
  },
  {
    label: 'Yellow',
    colour: TextColour.Yellow,
  },
  {
    label: 'Blue',
    colour: TextColour.Blue,
  },
  {
    label: 'Purple',
    colour: TextColour.Purple,
  },
  {
    label: 'Pink',
    colour: TextColour.Pink,
  },
  {
    label: 'Green',
    colour: TextColour.Green,
  },
  {
    label: 'Grey',
    colour: TextColour.Grey,
  },
];
